import Noty from "noty";
import "noty/lib/noty.css";
import "noty/lib/themes/metroui.css";

Noty.overrideDefaults({ theme: "metroui", layout: "bottomRight", timeout: 5000 });

class NotificationStore {
  success(text: string) {
    new Noty({ text, type: "success" }).show();
  }

  warning(text: string) {
    new Noty({ text, type: "warning" }).show();
  }

  error(text: string) {
    new Noty({ text, type: "error" }).show();
  }
}

const notificationStore = new NotificationStore();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).notificationStore = notificationStore;

export default notificationStore;
